import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { Card } from '../card';
export const HighlightedCard = (props)=>{
    const { borderColor , content , image , tag , title , ...cardProps } = props;
    return /*#__PURE__*/ React.createElement(Card, {
        borderColor: borderColor,
        borderLeftWidth: "4px",
        color: "text.primary",
        gap: 2,
        p: 1,
        ...!image && {
            pl: [
                2,
                null,
                3
            ]
        },
        variant: "highlighted",
        ...cardProps
    }, image && /*#__PURE__*/ React.createElement(Box, {
        as: "figure",
        borderRadius: "full",
        boxSize: "68px",
        flexShrink: 0,
        overflow: "hidden"
    }, image), /*#__PURE__*/ React.createElement(Flex, {
        direction: "column",
        gap: 0.5
    }, tag && /*#__PURE__*/ React.createElement(Text, {
        color: "brand.secondary",
        textStyle: "xsBold",
        textTransform: "uppercase"
    }, tag), /*#__PURE__*/ React.createElement(Text, {
        textStyle: "mBold"
    }, title), typeof content === 'string' ? content.length > 0 && /*#__PURE__*/ React.createElement(Text, {
        textStyle: "s"
    }, content) : content));
};

//# sourceMappingURL=highlighted-card.js.map